import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb } from '@fikasio/react-ui-components';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import EntityView from 'components/entities/EntityView';
import BasePage from 'components/UI/BasePage';
import { useGetEntitiesQuery } from 'services/entities/api';
import links, { matchesLinkKey } from 'utils/links';
import { spaLinkProps } from 'utils/spaLink';

const EntityPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { slug } = useParams<{ slug: string; }>();
  const { data: entities } = useGetEntitiesQuery();
  const entity = entities && entities.find(item => matchesLinkKey(item, slug));

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{`${t('entities')}${entity?.name ? ` - ${entity.name}` : ''}`}</title>
      </Helmet>
      <BasePage>
        <Breadcrumb
          items={[
            { ...spaLinkProps(links.paths.home, navigate), label: t('home') },
            { ...spaLinkProps(links.paths.entities, navigate), label: t('entities') },
            { label: entity?.name ?? '' },
          ]}
        />
        <h4>{ entity?.name }</h4>
        <br />
        {
          entity && (
            <EntityView
              entity={entity}
            />
          )
        }
      </BasePage>
    </>
  );
};

export default EntityPage;
